import type { NavigationGuard } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

export const authGuard: NavigationGuard = (to) => {
  const auth = useAuthStore()
  // If init() is still running, let the navigation proceed.
  // App.vue shows a spinner until initializing is false, at which point
  // the router will re-evaluate guards naturally on the next navigation or
  // via programmatic navigation from App.vue.
  if (auth.initializing) return undefined
  if (to.meta['requiresAuth'] === true && !auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  return undefined
}

export const accessGuard: NavigationGuard = (to) => {
  const auth = useAuthStore()
  if (auth.initializing) return undefined
  const right = to.meta['right'] as string | null | undefined
  if (right && !auth.hasRight(right)) {
    return { name: 'index' }
  }
  return undefined
}

/**
 * Block all navigation when passwordChangeRequired is true, except to
 * the change-password route and login route.
 * The backend enforces the same via 423 Locked; this is defence-in-depth.
 */
export const passwordChangeGuard: NavigationGuard = (to) => {
  const auth = useAuthStore()
  if (auth.initializing) return undefined
  if (
    auth.passwordChangeRequired &&
    to.name !== 'change-password' &&
    to.name !== 'login'
  ) {
    return { name: 'change-password' }
  }
  return undefined
}
